<template>
  <div class="menu-container">
    <div class="menu-item">
      <div class="menu-item-detail">
        <div class="logo" :style="{ backgroundColor: colorGenerator(currentUser.name) }">
          <span>{{currentUser.name.charAt(0) }}</span>
        </div>
        <div class="username">{{ cutString(currentUser.name)}}</div>
      </div>
      <div @click="onToggleSubMenuItem" v-if="showUserMenu" class="action-icon">
        <i class="fa" :class="[isToggleUserMenu ? 'fa-chevron-up' : 'fa-chevron-down']" />
      </div>
    </div>
    <slot name="submenu" v-if="isToggleUserMenu"></slot>
  </div>
</template>

<script>
import colorGenerator from '@/utils/colorGeneratorUtils';
// import colorGenerator from '../utils/colorGeneratorUtils';

export default {
  mixins: [colorGenerator],
  props: {
    currentUser: {
      type: Object,
      required: true,
    },
    showUserMenu: {
      type: Boolean,
      default: false,
    },
    isToggleUserMenu: {
      type: Boolean,
    },
  },
  methods: {
    cutString(string) {
      if (string.length > 12) {
        return `${string.substring(0, 12)} ...`;
      }
      return string;
    },
    onToggleSubMenuItem() {
      this.$emit('toggleUserMenu');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/menu.scss';

.menu-item-detail {
  .logo {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: $gray-700;
    color: $gray-200;

    display: flex;
    align-items: center;
    justify-content: center;

    text-transform: uppercase;

    font-size: $font-size-base * 1.25;
    margin-bottom: $spacer * 0.5;
  }
}

.menu-sub-item-container {
  .menu-sub-item {
    &.user-item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      label {
        font-size: $font-size-sm * 0.875;
        margin-bottom: 0;
      }
    }
  }
}
</style>
